<template lang="html">
  <div>
    <dress-codes-item v-model="selectedItemId" />
    <v-card
      v-if="!showItemOnly"
      :key="instanceKey"
    >
      <page-bar
        :title="pageTitle"
        :context-menu="defaultContextMenu"
        :loading="isDataLoading"
      />

      <api-errors :errors="errors" />

      <!-- LIST OF ITEMS -->
      <item-select-table
        :add-action="addNewItem"
        :add-label="'Add ' + type"
        :edit-action="editItem"
        :search="true"
        :items="items"
        :pagination.sync="pagination"
        :total-items="totalListItems"
        :headers="headers"
      />
    </v-card>
  </div>
</template>

<script>
import {itemSelect} from '@/ft-vue-core'
import DressCodesItem from './DressCodesItem'

export default {
  name: 'DressCodesList',
  components: {DressCodesItem},
  mixins: [itemSelect],
  data: function () {
    return {
      type: 'Dress Code',
      types: 'Dress Codes',
      headers: [
        this.headerText('Dress Code Name', 'name', true),
        this.headerText('Comments', 'notes', true),
        this.headerInvertedSwitch('Active', 'disabled')
      ],
      apiRecordCommand: 'diningDressCode'
    }
  },
  computed: {
  }
}
</script>
